import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  ProfileOutlined,
  TableOutlined,
} from '@ant-design/icons'
import Col from 'antd/es/grid/col'
import Row from 'antd/es/grid/row'
import Select, { BaseOptionType } from 'antd/es/select/index'
import Segmented from 'antd/es/segmented/index'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '@/redux/hooks.ts'
import {
  mobileViewCardOrderSel,
  selectIdeaListInput,
  setMobileView,
  setMobileViewCardOrder,
} from '@/redux/slices/idea-list-input.slice.ts'
import '@/pages/idea-list/components/idea-list-user-filter-controls-mobile.scss'

const SelectOption =
  ({
    type,
    t,
  }: {
    type: 'label' | 'option'
    t: TFunction<'translation', undefined>
  }) =>
  (option: BaseOptionType & { value?: string | number }) => {
    if (typeof option.value !== 'string') return null
    const [field, direction] = option.value.split('/')
    let className = ''
    switch (type) {
      case 'label':
        className = 'idea-list-user-filter-controls-mobile__label'
        break
      case 'option':
        className = 'idea-list-user-filter-controls-mobile__option'
        break
    }

    const optionsLabel: { [key: string]: string } = {
      CreatedAt: t('idea_list.idea_table.columns.created_at'),
      DailyReturnPct: t('idea_list.idea_table.columns.daily_return_pct'),
      QuarterPnl: t('idea_list.idea_table.columns.quarter_pnl'),
      TotalReturnPct: t('idea_list.idea_table.columns.total_return_pct'),
      TotalPnl: t('idea_list.idea_table.columns.current_total_pnl'),
    }

    return (
      <div className={className}>
        <span>{optionsLabel[field] ?? field}</span>
        {direction === 'ASC' && (
          <ArrowUpOutlined
            className={'idea-list-user-filter-controls-mobile__option__icon'}
          />
        )}
        {direction === 'DESC' && (
          <ArrowDownOutlined
            className={'idea-list-user-filter-controls-mobile__option__icon'}
          />
        )}
      </div>
    )
  }

export const IdeaListUserFilterControlsMobile: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const ideaListInput = useAppSelector(selectIdeaListInput)

  return (
    <Col flex={1}>
      <Row
        justify={ideaListInput.mobileView === 'card' ? 'space-between' : 'end'}
        align={'middle'}
      >
        {ideaListInput.mobileView === 'card' && (
          <Col xs={{ flex: '0 0 50%' }}>
            <Select
              style={{ width: '100%' }}
              placeholder={'Sort by'}
              onChange={(value) => {
                dispatch(setMobileViewCardOrder(value))
              }}
              labelRender={SelectOption({ type: 'label', t })}
              options={mobileViewCardOrderSel.map((option) => ({
                label: option,
                value: option,
              }))}
              optionRender={SelectOption({ type: 'option', t })}
            />
          </Col>
        )}
        <Col>
          <Segmented
            value={ideaListInput.mobileView}
            onChange={(value) => {
              dispatch(setMobileView(value))
            }}
            options={[
              {
                value: 'card',
                label: <ProfileOutlined />,
              },
              {
                value: 'table',
                label: <TableOutlined />,
              },
            ]}
          />
        </Col>
      </Row>
    </Col>
  )
}
